import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class GetAllDynamicPages extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("DynamicPage/GetAll");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetPageBySeoUrl extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("DynamicPage/GetBySEOURL");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetPageById extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("DynamicPage/GetBy");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class UpdateADynamicPage extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("DynamicPage/Update");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

export { GetAllDynamicPages, GetPageBySeoUrl, GetPageById, UpdateADynamicPage };
